import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import util from '@utils/util';
import personalContent from './components/personalContent';
import ReHeader from '../../../basic/re_header';
import ReFooter from '../../../basic/re_footer';
export default {
  name: 'pagePersonal',
  data: function data() {
    return {
      countryCode: '',
      CommonAPIService: null,
      personalid: this.$route && this.$route.params.personalId || '0'
    };
  },
  components: {
    personalContent: personalContent,
    'website-header': ReHeader,
    'website-footer': ReFooter
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return util.getI18nCountryCode();
          case 2:
            _this.countryCode = _context.sent;
            util.handeError();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};